
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { Loader2 } from 'lucide-react';

const StaffLoading: React.FC = () => {
  return (
    <div className="space-y-6 animate-pulse">
      <div className="flex justify-center mb-8">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
      
      <Skeleton className="h-12 w-3/4 mx-auto mb-6" />
      
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center gap-4">
            <Skeleton className="h-16 w-16 rounded-full" />
            <div className="space-y-2">
              <Skeleton className="h-6 w-48" />
              <div className="flex gap-2">
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-4 w-24" />
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <div className="space-y-4 mt-8">
        <Skeleton className="h-8 w-full" />
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-12 w-full" />
      </div>
    </div>
  );
};

export default StaffLoading;
